var default_styles_default = {
  "button_container": "w7wgk",
  "button_text": "hDuTB",
  "button_size_content": "jqs32"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
